import { useState,useRef, useEffect } from "react";
import { Contact } from "../pages/Contact";
import { Profile } from "../pages/Profile";
import { Projects } from "../pages/Projects";
import MegaScroll from "./MegaScroll.tsx";
import {useWindowDimensions} from './useWindowDimension.js'

export const Main = ({ darkMode, setDarkMode, active, setActive , manualScroll, setManualScroll }) => {
  const {height,width} = useWindowDimensions()

  const [popup, setPopup] = useState(null);
  const profileRef = useRef(null);
  const projectRef =useRef(null)
  const contactRef =useRef(null)

  const megaScrollRef = useRef(null);
  const sections = ["profile", "project", "contact"];

  
  useEffect(() => {
    if (active === "profile") {
      profileRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else if (active === "project") {
      projectRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else if (active === "contact") {
      contactRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    if(width > 767){
      setTimeout(()=>{
        setManualScroll(false)
      },1000)
    }
  }, [active]);



  useEffect(()=>{
    if(width < 767)
      setManualScroll(true);
    else
      setManualScroll(false);

  },[width])




  return (
    <div className="w-full space-y-10  md:h-screen  h-full  overflow-y-auto md:overflow-hidden">
      <MegaScroll
        ref={megaScrollRef}
        onChange={(index) => setActive(sections[index])}
        manualScroll={manualScroll}
      >
        <Profile ref={profileRef} darkMode={darkMode} />
        <Projects
          className=" "
          ref={projectRef}
          darkMode={darkMode}
          setDarkMode={setDarkMode}
          popup={popup}
          setPopup={setPopup}
        />
        <Contact ref={contactRef} darkMode={darkMode} />
      </MegaScroll>
    </div>
  );
};


